<template>
  <div class="list-item d-flex" :class="`size-${size}`">
    <div class="label flex-shrink-0 d-flex align-center">{{ label }}</div>
    <div class="content flex-grow-1">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "normal"
    }
  }
};
</script>

<style lang="scss" scoped>
.list-item {
  font-size: 14px;

  & + & {
    margin-top: 2px;
  }

  .label {
    width: 140px;
    background-color: #EEE;
    color: #777;
    padding: 10px;
    margin-right: 2px;
  }

  .content {
    color: #555;
    background-color: #F5F5F5;
    padding: 10px;
  }

  &.size-small {
    font-size: 12px;

    .label {
      width: 80px;
      padding: 8px 10px;
    }

    .content {
      padding: 8px 10px;
    }
  }
}
</style>
